// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kvCmO","backButton":"Header_backButton__r0dVP","rightButton":"Header_rightButton__3ogta","Base":"Header_Base__gyDu8"};